import { useEffect, useMemo, useRef, useState } from "react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { FestivalEventNoticeItem, FestivalEventNoticeTable } from "./style";
import { FestivalEventITMWrapper, FestivalEventITMHeader } from "../itm/style";

const RabbitFestivalEventNotice = () => {
  const { event } = useRabbitFestivalContext();
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open ? contentRef.current.scrollHeight + 56 + 20 : 56);
    }
  }, [open]);

  const noticeList = useMemo(() => {
    if (!event || !event.tournament.competition) return [];
    return [
      { title: "공지사항", value: event?.tournament.competition?.notice },
      { title: "주최", value: event?.tournament.competition?.host },
      { title: "주관", value: event?.tournament.competition?.organizer },
    ];
  }, [event]);

  return (
    <FestivalEventITMWrapper contentHeight={contentHeight}>
      <FestivalEventITMHeader onClick={() => setOpen(!open)} open={open}>
        <div className="title">상세정보</div>
        <img src="image-web/rabbit/down_arrow.svg" alt="more" />
      </FestivalEventITMHeader>
      <FestivalEventNoticeTable ref={contentRef} open={open}>
        {noticeList.map((item, index) => (
          <FestivalEventNoticeItem key={index}>
            <div className="title">{item.title}</div>
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: (item.value || "").replace(/\n/g, "<br/>"),
              }}
            />
          </FestivalEventNoticeItem>
        ))}
      </FestivalEventNoticeTable>
    </FestivalEventITMWrapper>
  );
};

export default RabbitFestivalEventNotice;
